import {useWatch} from 'react-hook-form'

import {useFieldConfigurationContext} from '../../configuration/useConfigurationContext'
import {useFormEffect} from '../../form/useFormEffect'
import {useOrderProcessFormContext} from '../../form/useOrderProcessFormContext'
import {QuantitySelection} from '../quantity/types'

import {getTruckSize, isMultipleTruck} from './trucks.utils'

export const useAdjustMultipleTrucks = () => {
  const {control, setValue} = useOrderProcessFormContext()
  const truckConfiguration = useFieldConfigurationContext('trucks')
  const [truckType, quantitySelection] = useWatch({
    name: ['truckType', 'quantity'],
    control
  })

  const typedQuantity = quantitySelection as QuantitySelection

  useFormEffect(() => {
    // When full loads are selected, derive isMultipleTruck directly from load count
    if (typedQuantity.type === 'fullLoads') {
      setValue('isMultipleTruck', typedQuantity.fullLoads >= 2, {shouldValidate: true})
      return
    }

    // Default: derive from quantity vs truck size
    const truckSize = getTruckSize(truckConfiguration, truckType)
    setValue('isMultipleTruck', isMultipleTruck(typedQuantity.volume, truckSize), {
      shouldValidate: true
    })
  }, [truckType, typedQuantity])
}
